export const sortByComparators = <T>(
  items: T[] | undefined,
  sortBy: string,
  comparators: Record<string, (a: T, b: T) => number>
): T[] => {
  if (!items) return [];

  const comparator = comparators[sortBy];

  if (comparator) {
    return [...items].sort(comparator);
  }

  return items;
};
